exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\r\n    display: flex;\r\n    flex: 1 1 auto;\r\n    margin-top: 7px;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./Scripts/app/home/home.component.css
// module id = 2314
// module chunks = 1